import React from "react";
import { Footer, Navbar } from "../components";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";

const Checkout = () => {
  const [email, setEmail] = useState("");
  const [costoTotal, setCostoTotal] = useState("");
  const [subTotal, setCostoSubtotal] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellidos, setApellidos] = useState("");
  const [envio, setEnvio] = useState("");

  const state = useSelector((state) => state.handleCart);

  let subtotal = 0;
    let shipping = 30.0;
    let totalItems = 0;

    state.map((item) => {
      return (subtotal += item.precio * item.qty);
    });

    state.map((item) => {
      return (totalItems += item.qty);
    });

    const totalValue = Math.round(subtotal + shipping);

    useEffect(() => {
      setCostoSubtotal(subtotal);
      setCostoTotal(totalValue);
      setEnvio(shipping);
    }, [subtotal, shipping, totalValue]);

    const sendEmail = async (e) => {
      e.preventDefault();
      console.log(email);
      const data = {
        email: email,
        total: costoTotal,
        subtotal: subTotal,
        name: nombre,
        apellidos: apellidos,
        envio: envio,
      };
      //const response = await axios.post("https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/sendemail",data)
      const response = await axios.post(
        "https://us-central1-ecommerce-nemotec.cloudfunctions.net/app/api/sendemail",
        data
      );
      console.log(response);
      console.log(data);
    };
    
  return (
    <>
      <Navbar />
      <div className="container my-3 py-3">
        <h1 className="text-center">Compra</h1>
        <hr />
        {state.length > 0 ?
        <>
        <div className="container py-5">
          <div className="row my-4">
            <div className="col-md-5 col-lg-4 order-md-last">
              <div className="card mb-4">
                <div className="card-header py-3 bg-light">
                  <h5 className="mb-0">Resumen del pedido</h5>
                </div>
                <div className="card-body">
                  <ul className="list-group list-group-flush">
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 pb-0">
                      Productos ({totalItems})
                      <span>${Math.round(subtotal)}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center px-0">
                      Envío
                      <span>${shipping}</span>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center border-0 px-0 mb-3">
                      <div>
                        <strong>Costo total</strong>
                      </div>
                      <span>
                        <strong>${Math.round(subtotal + shipping)}</strong>
                      </span>
                      <input
                        type="text"
                        value={costoTotal}
                        style={{ display: "none" }}
                        onChange={(e) => setCostoTotal(e.target.value)}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-md-7 col-lg-8">
              <div className="card mb-4">
                <div className="card-header py-3">
                  <h4 className="mb-0">Dirección de facturación</h4>
                </div>

                <div className="card-body">
                  <form className="needs-validation" onSubmit={sendEmail}>
                    <div className="row g-3">
                      <div className="col-sm-6 my-1">
                        <label htmlFor="nombre" className="form-label">
                          Nombre(s)
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="nombre"
                          placeholder=""
                          onChange={(e) => setNombre(e.target.value)}
                          required
                        />
                        <div className="invalid-feedback">
                          Debes ingresar un nombre valido.
                        </div>
                      </div>

                      <div className="col-sm-6 my-1">
                        <label htmlFor="lastName" className="form-label">
                          Apellidos
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="lastName"
                          placeholder=""
                          onChange={(e) => setApellidos(e.target.value)}
                          required
                        />
                        <div className="invalid-feedback">
                          Debes ingresar un apellido valido.
                        </div>
                      </div>

                      <div className="col-12 my-1">
                        <label htmlFor="email" className="form-label">
                          Correo electrónico
                        </label>
                        <input
                          type="email"
                          className="form-control"
                          id="email"
                          placeholder="you@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                        <div className="invalid-feedback">
                          Por favor ingrese un correo electrónioco valido.
                        </div>
                      </div>

                      <div className="col-12 my-1">
                        <label htmlFor="address" className="form-label">
                          Dirección
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address"
                          placeholder="1234 Main St"
                          required
                        />
                        <div className="invalid-feedback">
                          Por favor ingrese su dirección
                        </div>
                      </div>

                      <div className="col-12">
                        <label htmlFor="address2" className="form-label">
                          Dirección 2{" "}
                          <span className="text-muted">(Optional)</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="address2"
                          placeholder="Apartment or suite"
                        />
                      </div>

                      <div className="col-md-5 my-1">
                        <label htmlFor="country" className="form-label">
                          Estado
                        </label>
                        <br />
                        <select className="form-select" id="country" required>
                          <option value="">Seleccióne</option>
                          <option>México</option>
                          <option>Hidalgo</option>
                          <option>Guerrero</option>
                          <option>Jalisco</option>
                          <option>Puebla</option>
                        </select>
                        <div className="invalid-feedback">
                          Por favor ingrese un estado valido.
                        </div>
                      </div>

                      <div className="col-md-4 my-1">
                        <label htmlFor="estado" className="form-label">
                          Municipio
                        </label>
                        <br />
                        <select className="form-select" id="estado" required>
                          <option value="">Seleccióne</option>
                          <option>Jocotitlán</option>
                          <option>Jilotepec</option>
                          <option>Atlacomulco</option>
                          <option>Toluca</option>
                          <option>Ixtlahuaca</option>
                        </select>
                        <div className="invalid-feedback">
                          Por favor ingrese un municipio valido.
                        </div>
                      </div>

                      <div className="col-md-3 my-1">
                        <label htmlFor="zip" className="form-label">
                          Codigo postal
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="zip"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Ingrese el codigo postal.
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <h4 className="mb-3">Pago</h4>

                    <div className="row gy-3">
                      <div className="col-md-6">
                        <label htmlFor="cc-name" className="form-label">
                          Nombre en la tarjeta
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-name"
                          placeholder=""
                          required
                        />
                        <small className="text-muted">
                          Nombre completo registrado en la tarjeta.
                        </small>
                        <div className="invalid-feedback">
                          Se requiere el nombre completo.
                        </div>
                      </div>

                      <div className="col-md-6">
                        <label htmlFor="cc-number" className="form-label">
                          Numero de la tarjeta
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-number"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Se requiere el numero de la tarjeta.
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="cc-expiration" className="form-label">
                          Expiración
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-expiration"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Fecha de expiración requerida.
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="cc-cvv" className="form-label">
                          CVV
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="cc-cvv"
                          placeholder=""
                          required
                        />
                        <div className="invalid-feedback">
                          Codigo de seguridad requerido.
                        </div>
                      </div>
                    </div>

                    <hr className="my-4" />

                    <button
                      className="w-100 btn btn-primary "
                      type="submit"
                      onClick={(e) => sendEmail(e)} //document.getElementById('email').value
                    >
                      Continuar con el proceso del pago
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
        : 
        <div className="container">
        <div className="row">
          <div className="col-md-12 py-5 bg-light text-center">
            <h4 className="p-3 display-5">No hay productos en el carrito</h4>
            <Link to="/" className="btn btn-outline-dark mx-4">
              <i className="fa fa-arrow-left"></i> Continuar comprando
            </Link>
          </div>
        </div>
      </div>
        }
      </div>
      <Footer />
    </>
  );
};

export default Checkout;
